import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Blog from "./pages/Blog";
import Cart from "./pages/Cart";
import Home from "./pages/Home";
import Post from "./pages/Post";
import Product from "./pages/Product";
import Whishlist from "./pages/Whishlist";
import ErrorPage from "./pages/ErrorPage";
import Packages from "./pages/Packages";
import Services from "./pages/Services";
import Bookings from "./pages/Bookings";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Shop from "./pages/Shop";
import Orders from "./pages/Orders";

import { categoriesData, serviceItems } from "./api/index";
import LayoutHeader from "./utilities/LayoutHeader";
import LayoutFooter from "./utilities/LayoutFooter";

// admin routes imports
import AdminLogin from "./pages/Admin/Login";
import Dashboard from "./pages/Admin/Dashboard";
import AdminProducts from "./pages/Admin/Products";
import AdminServices from "./pages/Admin/Services";
import AdminBookings from "./pages/Admin/Bookings";
import AdminPosts from "./pages/Admin/Posts";
import AdminOrders from "./pages/Admin/Orders";
import AdminUsers from "./pages/Admin/Users";

import { apiURL } from "../src/api/index";
import { useSelector } from "react-redux";

function App() {
  const [darkMode, setDarkMode] = useState(
    JSON.parse(localStorage.getItem("darkmode"))
  );
  const [products, setProducts] = useState([]);
  const [posts, setPosts] = useState([]);
  const [services, setServices] = useState([]);
  const [users, setUsers] = useState([]);
  const [orders, setOrders] = useState([]);
  const [bookings, setBookings] = useState([]);

  const [categories, setCategories] = useState([]);
  const [servicesItems, setServicesItems] = useState([]);

  const cart = useSelector((state) => state.AddToCart);
  const wishlist = useSelector((state) => state.AddToWhishList);

  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cart));
  }, [cart]);

  useEffect(() => {
    localStorage.setItem("wishlistItems", JSON.stringify(wishlist));
  }, [wishlist]);

  //fetching data from backend or api/index and passing data as props to rest of components to use the data.
  useEffect(() => {
    setServicesItems(serviceItems);
    setCategories(categoriesData);

    Promise.all([
      fetch(`${apiURL}/products`).then((response) => response.json()),
      fetch(`${apiURL}/posts`).then((response) => response.json()),
      fetch(`${apiURL}/services`).then((response) => response.json()),
      fetch(`${apiURL}/users`).then((response) => response.json()),
      fetch(`${apiURL}/orders`).then((response) => response.json()),
      fetch(`${apiURL}/bookings`).then((response) => response.json()),
    ])
      .then(
        ([
          productsData,
          postsData,
          servicesData,
          usersData,
          ordersData,
          bookingsData,
        ]) => {
          setProducts(productsData);
          setPosts(postsData);
          setServices(servicesData);
          setUsers(usersData);
          setOrders(ordersData);
          setBookings(bookingsData);
        }
      )
      .catch((error) => console.error(error));
  }, []);

  function enableDarkMode() {
    setDarkMode(!darkMode);
    localStorage.setItem("darkmode", JSON.stringify(!darkMode));
  }

  return (
    <div className={darkMode ? "dark" : ""}>
      <BrowserRouter>
        <LayoutHeader
          hideHeaderPaths={[
            "/login",
            "/register",
            "/admin",
            "/admin/dashboard",
            "/admin/products",
            "/admin/orders",
            "/admin/services",
            "/admin/posts",
            "/admin/users",
            "/admin/bookings",
          ]}
          categories={categories}
          products={products}
        />
        <Routes>
          <Route
            path="/"
            element={
              <Home
                products={products}
                posts={posts}
                services={services}
                categories={categories}
              />
            }
          />
          <Route path="/cart" element={<Cart />} />
          <Route path="/whishlist" element={<Whishlist />} />
          <Route path="/blog" element={<Blog posts={posts} />} />
          <Route path="/post/:id" element={<Post />} />
          <Route path="/product/:id" element={<Product />} />
          <Route path="/orders" element={<Orders orders={orders} />} />
          <Route path="/bookings" element={<Bookings bookings={bookings} />} />
          <Route
            path="/shop/:category"
            element={<Shop products={products} categories={categories} />}
          />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/services/:category"
            element={
              <Services services={services} servicesItems={servicesItems} />
            }
          />
          <Route path="/packages" element={<Packages />} />

          {/* admin routes starts here*/}
          <Route path="/admin" element={<AdminLogin />} />
          <Route
            path="/admin/dashboard"
            element={
              <Dashboard
                services={services}
                products={products}
                orders={orders}
                bookings={bookings}
                enableDarkMode={enableDarkMode}
                darkMode={darkMode}
              />
            }
          />
          <Route
            path="/admin/products"
            element={
              <AdminProducts
                products={products}
                enableDarkMode={enableDarkMode}
                darkMode={darkMode}
              />
            }
          />
          <Route
            path="/admin/posts"
            element={
              <AdminPosts posts={posts} enableDarkMode={enableDarkMode} />
            }
          />
          <Route
            path="/admin/services"
            element={
              <AdminServices
                services={services}
                enableDarkMode={enableDarkMode}
              />
            }
          />
          <Route
            path="/admin/bookings"
            element={
              <AdminBookings
                bookings={bookings}
                enableDarkMode={enableDarkMode}
              />
            }
          />
          <Route
            path="/admin/orders"
            element={
              <AdminOrders orders={orders} enableDarkMode={enableDarkMode} />
            }
          />
          <Route
            path="/admin/users"
            element={
              <AdminUsers users={users} enableDarkMode={enableDarkMode} />
            }
          />

          {/* admin routes ends here*/}

          <Route path="*" element={<ErrorPage />} />
        </Routes>
        <LayoutFooter
          hideFooterPaths={[
            "/login",
            "/register",
            "/admin",
            "/admin/dashboard",
            "/admin/products",
            "/admin/orders",
            "/admin/services",
            "/admin/users",
            "/admin/posts",
            "/admin/bookings",
          ]}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
